<template>
  <ol class="fz-18 text-white  list-decimal pl-5">
    <li v-for="item in items" :key="item">{{ item }}</li>
  </ol>
</template>

<script>
export default {
  name: "numberedList",
  props: ['items']
}
</script>

<style scoped>

</style>